import { render } from "./TripForm.vue?vue&type=template&id=85935dcc"
import script from "./TripForm.vue?vue&type=script&lang=js"
export * from "./TripForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__